import "./assets/js/nav-pills.js";
import "./assets/scss/dashboard.scss";

export default {
  install() {},
};
